import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

/**
 * `unit` labels the y-axis ticks and tooltip values (e.g. 'pts', '$', 'orders').
 * `formatValue` optionally formats the raw number before the unit is appended.
 */
const LineChart = ({ data, height = 300, className = '', unit = '', formatValue = (v) => v }) => {
	const options = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: { position: 'bottom', labels: { usePointStyle: true, padding: 20, font: { size: 12, family: 'Poppins' } } },
			tooltip: {
				mode: 'index',
				intersect: false,
				backgroundColor: 'rgba(0, 0, 0, 0.8)',
				titleFont: { family: 'Poppins', size: 14 },
				bodyFont: { family: 'Poppins', size: 13 },
				cornerRadius: 8,
				displayColors: true,
				callbacks: {
					title: (tooltipItems) => `${tooltipItems[0].label}`,
					label: (context) => `${context.dataset.label}: ${formatValue(context.parsed.y)}${unit}`
				}
			}
		},
		interaction: { mode: 'nearest', axis: 'x', intersect: false },
		scales: {
			x: {
				display: true,
				grid: { display: false },
				border: { display: false },
				ticks: { font: { family: 'Poppins', size: 12 }, color: '#6B7280' }
			},
			y: {
				display: true,
				grid: { color: 'rgba(107, 114, 128, 0.1)', drawBorder: false },
				border: { display: false },
				ticks: {
					font: { family: 'Poppins', size: 12 },
					color: '#6B7280',
					callback: function (value) { return `${formatValue(value)}${unit}`; }
				}
			}
		},
		elements: {
			line: { tension: 0.4 },
			point: { radius: 4, hoverRadius: 6, borderWidth: 2, hoverBorderWidth: 3 }
		},
		animation: { duration: 1000, easing: 'easeInOutQuart' }
	};

	return (
		<div className={`w-full ${className}`}>
			<div style={{ height: `${height}px` }}>
				<Line data={data} options={options} />
			</div>
		</div>
	);
};

export default LineChart;
